/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboCashManagementBadRequestResponse,
  BboCashManagementForbiddenResponse,
  FailureResponseResponse,
  GetCashCountHistoryListFiltersParams,
  GetCashCountHistoryListFiltersResponseResponse,
  GetCashCountHistoryListFiltersResponseV2Response,
  GetCashCountHistoryListFiltersV2Params,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Cash Count History list filters
 * @summary Get All filters for Cash Count History
 */
export const getCashCountHistoryListFilters = (
  params?: GetCashCountHistoryListFiltersParams,
  signal?: AbortSignal,
) => {
  return customInstance<GetCashCountHistoryListFiltersResponseResponse>({
    url: `/BboCashManagementService/v1/cash-count/list/filters`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetCashCountHistoryListFiltersQueryKey = (
  params?: GetCashCountHistoryListFiltersParams,
) => {
  return [
    `/BboCashManagementService/v1/cash-count/list/filters`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetCashCountHistoryListFiltersQueryOptions = <
  TData = Awaited<ReturnType<typeof getCashCountHistoryListFilters>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | FailureResponseResponse
  >,
>(
  params?: GetCashCountHistoryListFiltersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCashCountHistoryListFilters>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCashCountHistoryListFiltersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCashCountHistoryListFilters>>> = ({
    signal,
  }) => getCashCountHistoryListFilters(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCashCountHistoryListFilters>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCashCountHistoryListFiltersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCashCountHistoryListFilters>>
>;
export type GetCashCountHistoryListFiltersQueryError = ErrorType<
  | BboCashManagementBadRequestResponse
  | UnauthorizedResponse
  | BboCashManagementForbiddenResponse
  | FailureResponseResponse
>;

/**
 * @summary Get All filters for Cash Count History
 */
export const useGetCashCountHistoryListFilters = <
  TData = Awaited<ReturnType<typeof getCashCountHistoryListFilters>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | FailureResponseResponse
  >,
>(
  params?: GetCashCountHistoryListFiltersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCashCountHistoryListFilters>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCashCountHistoryListFiltersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Cash Count History list filters
 * @summary Get All filters for Cash Count History
 */
export const getCashCountHistoryListFiltersV2 = (
  params?: GetCashCountHistoryListFiltersV2Params,
  signal?: AbortSignal,
) => {
  return customInstance<GetCashCountHistoryListFiltersResponseV2Response>({
    url: `/BboCashManagementService/v2/cash-count/list/filters`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetCashCountHistoryListFiltersV2QueryKey = (
  params?: GetCashCountHistoryListFiltersV2Params,
) => {
  return [
    `/BboCashManagementService/v2/cash-count/list/filters`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetCashCountHistoryListFiltersV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getCashCountHistoryListFiltersV2>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | FailureResponseResponse
  >,
>(
  params?: GetCashCountHistoryListFiltersV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCashCountHistoryListFiltersV2>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCashCountHistoryListFiltersV2QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCashCountHistoryListFiltersV2>>> = ({
    signal,
  }) => getCashCountHistoryListFiltersV2(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCashCountHistoryListFiltersV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCashCountHistoryListFiltersV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getCashCountHistoryListFiltersV2>>
>;
export type GetCashCountHistoryListFiltersV2QueryError = ErrorType<
  | BboCashManagementBadRequestResponse
  | UnauthorizedResponse
  | BboCashManagementForbiddenResponse
  | FailureResponseResponse
>;

/**
 * @summary Get All filters for Cash Count History
 */
export const useGetCashCountHistoryListFiltersV2 = <
  TData = Awaited<ReturnType<typeof getCashCountHistoryListFiltersV2>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | FailureResponseResponse
  >,
>(
  params?: GetCashCountHistoryListFiltersV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCashCountHistoryListFiltersV2>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCashCountHistoryListFiltersV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
